import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  indicatorsWrapper: {
    width: '100%',
    display: 'flex',
    height: '6.5vh',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  item: {
    width: '16px',
    height: '16px',
    border: `1px solid ${theme.palette.other.lightGrey}`,
    borderRadius: '50px',
    marginLeft: theme.spacing(0.35),
    marginRight: theme.spacing(0.35),
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    }
  },
  active: {
    background: theme.palette.other.blue,
  },
}))
